import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-system-activity',
  templateUrl: './system-activity.component.html',
  styleUrls: ['./system-activity.component.scss']
})
export class SystemActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/system-activity/system-activity.component.ts